import { debounce } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from './Button/Button';
import PlusIcon from './icon/plusIcon';
import style from './pushPanel.module.css';
import SearchInput from './SearchInput/SearchInput';

interface PushPanelProps {
  onSearch: (query: string) => void;
  onActiveClick: () => void;
  onCompletedClick: () => void;
  onClear: () => void;
  onCreateClick?: () => void;
  activeType: 'active' | 'completed';
}

const PushPanel: React.FC<PushPanelProps> = ({
  onSearch,
  onActiveClick,
  onCompletedClick,
  onCreateClick,
  onClear,
  activeType,
}) => {
  const [query, setQuery] = useState<string>('');
  const location = useLocation();

  const debouncedSearch = useMemo(
    () =>
      debounce((searchQuery: string) => {
        onSearch(searchQuery);
      }, 500),
    [onSearch],
  );

  const handleSearchChange = (searchQuery: string) => {
    setQuery(searchQuery);
    debouncedSearch(searchQuery);
  };

  const handleClearSearch = () => {
    setQuery('');
    debouncedSearch.cancel();
    onClear();
  };

  const getButtonContent = () => {
    if (location.pathname === '/plan') {
      return 'Вхідні заявки';
    } else if (location.pathname === '/push_message') {
      return 'Завершені';
    }
    return 'Вхідні заявки';
  };

  return (
    <div className={style.panel_wrap}>
      <div className={style.defaultStaffs}>
        <div className={style.wrapState}>
          <Button
            content="Активні"
            isActive={activeType === 'active'}
            onClick={onActiveClick}
          />
          <Button
            content={getButtonContent()}
            isActive={activeType === 'completed'}
            onClick={onCompletedClick}
          />
        </div>
        <SearchInput
          query={query}
          setQuery={setQuery}
          onSearchChange={handleSearchChange}
          onClear={handleClearSearch}
        />
      </div>
      {location.pathname === '/push_message' && (
        <div className={style.addActiveButton}>
          <Button
            content={
              <div className={style.buttonContent}>
                <PlusIcon />
                <span>Додати</span>
              </div>
            }
            onClick={onCreateClick}
          />
        </div>
      )}
    </div>
  );
};

export default PushPanel;
